import { useState } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import styles from './index.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { payAsYouGo, subscriptions } from './config';

const Buy = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userId = useSelector((state) => state.global.userId);

  const [tabActiveIndex, setTabActiveIndex] = useState(0);

  const jumpBuy = (item) => {
    if (!userId) {
      return dispatch({
        type: 'global/setShowLogin',
        payload: true,
      });
    }
    const url = item.url + '?checkout[custom][user_id]=' + userId;
    window.open(url, '_blank');
  };

  return (
    <div className={styles.price}>
      <Header />

      <div className={`${styles['container']} ${styles['container2']}`}>
        <div className={styles['header']}>
          <h1 className={styles['title']}>{t('pricing.plusModel')}</h1>

          <h2 className={styles['subtitle']}>{t('pricing.title')}</h2>
        </div>

        <div className={styles['tab-container']}>
          {[t('pricing.payAsYouGo'), t('pricing.subscriptions')].map((item, index) => {
            return (
              <div
                onClick={() => setTabActiveIndex(index)}
                key={item}
                className={`${styles['tab']} ${tabActiveIndex === index && styles['active']}`}
              >
                {item}
              </div>
            );
          })}
        </div>

        {tabActiveIndex === 0 && (
          <>
            <h3 className={styles['section-title']}>{t('pricing.payAsYouGoPacks')}</h3>

            <div className={styles['plans-container']}>
              {payAsYouGo.map((item) => {
                return (
                  <div key={item.price} className={styles['plan-card']}>
                    {item.best && <div className={styles['featured-badge']}>{t('pricing.bestValue')}</div>}
                    <h4 className={styles['plan-title']}>{t(item.titleKey)}</h4>

                    {item.save && <div className={styles['savings-tag']}>{t('pricing.save', { value: item.save })}</div>}

                    <p className={styles['plan-price']}>{item.price}</p>
                    <p className={styles['price-period']}>{t(item.validForKey)}</p>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.ultraQuota')}</span>

                      <span className={styles['feature-value']}>{item.ultraQuota.toLocaleString()}</span>
                    </div>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.plusQuota')}</span>

                      <span className={styles['feature-value']}>{item.plusQuota.toLocaleString()}</span>
                    </div>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.validFor')}</span>

                      <span className={styles['feature-value']}>{t(item.validForKey)}</span>
                    </div>
                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>
                        {item.supportLevel === 'priority' ? t('pricing.prioritySupport') : t('pricing.standardSupport')}
                      </span>
                    </div>

                    <p className={styles['value-prop']}>{t(item.infoKey)}</p>

                    <a href="#purchase-basic" onClick={() => jumpBuy(item)} className={styles['plan-button']}>
                      {t('pricing.purchaseNow')}
                    </a>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {tabActiveIndex === 1 && (
          <>
            <h3 className={styles['section-title']}>{t('pricing.subscriptionPlans')}</h3>

            <div className={styles['plans-container']}>
              {subscriptions.map((item) => {
                return (
                  <div key={item.price} className={styles['plan-card']}>
                    {item.best && <div className={styles['featured-badge']}>{t('pricing.bestValue')}</div>}
                    <h4 className={styles['plan-title']}>{t(item.titleKey)}</h4>

                    {item.save && <div className={styles['savings-tag']}>{t('pricing.save', { value: item.save })}</div>}

                    <p className={styles['plan-price']}>{item.price}</p>

                    <p className={styles['price-period']}>{t(item.subtitleKey)}</p>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.ultraQuota')}</span>

                      <span className={styles['feature-value']}>{item.ultraQuota.toLocaleString()}</span>
                    </div>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.plusQuota')}</span>

                      <span className={styles['feature-value']}>{item.plusQuota.toLocaleString()}</span>
                    </div>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.prioritySupport')}</span>
                    </div>

                    <div className={styles['feature-item']}>
                      <span className={styles['check-icon']}>✓</span>

                      <span className={styles['feature-text']}>{t('pricing.cancelAnytime')}</span>
                    </div>

                    <p className={styles['value-prop']}>{t(item.infoKey)}</p>

                    <a href="#subscribe-monthly" onClick={() => jumpBuy(item)} className={styles['plan-button']}>
                      {t('pricing.subscribeNow')}
                    </a>
                  </div>
                );
              })}
            </div>
          </>
        )}

        <div className={styles['footer']}>
          <p>
            {t('pricing.notePrefix')}
            <b>{t('pricing.notePaymentMethods')}</b>
            {t('pricing.noteSuffix')}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Buy;
